<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.Level2"
    title="identialert"
    secondarySubtitle="When your pet goes missing, you panic. Every minute matters. <br><br> 
    If the worst happens, our 24/7 team quickly mobilises local pet finders, vets, and keepers to help. 
    We’ll instantly create social media posts and posters. <br><br>
    Our service is proven to be the most effective way of reuniting you & your pet."
    badgeUri="/assets/images/identibase/identiAlert/hero-badge-10.svg"
    (onBuyClick)="buyIdentiAlertSubscription()"
    [compareVisible]="buyButtonVisible"
    [levelsVisible]="true"
    (onCompareClick)="compareClick()"
    [disabled]="!hasIdentiAlertOption && isAuthenticated"
    [buyHidden]="!buyButtonVisible"
  ></app-product-hero>

  <div class="row py-4 light-background">
    <div class="col-12 text-center px-3">
      <div class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center">
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/care-icon.svg"
            alt="care-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Over 70% of missing pets with premium accounts made it home safely
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/alert-badge.svg"
            alt="alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Instant alerts to local police, vets & wardens
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/sms-alert-badge.svg"
            alt="sms-alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            We’ll create posters <br> and contact pet keepers <br> in your area
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/box-approved.svg"
            alt="box-approved"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Includes all the features of <b>identibase+</b>
          </h6>
        </div>
      </div>
      <button
        *ngIf="buyButtonVisible"
        (click)="buyIdentiAlertSubscription()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
        [disabled]="!hasIdentiAlertOption && isAuthenticated"
      >
        Buy now
      </button>
    </div>
  </div>
  <div class="container">
    <div class="trustpilot-section">
      <div class="trustpilot-section-desktop">
        <app-trustbox-testimonials-desktop></app-trustbox-testimonials-desktop>
      </div>
      <div class="trustpilot-section-mobile">
        <app-trustbox-testimonials-mobile></app-trustbox-testimonials-mobile>
      </div>
    </div>
  </div>
  <div class="row pt-5 mid-background" *ngIf="buyButtonVisible">
    <div class="col-12 text-center position-relative">
      <h3 class="mb-3">Get complete peace of mind</h3>
      <a *ngIf="hasIdentiFindOption && isAuthenticated" [routerLink]="[]" (click)="buyIdentiFindSubscription()"
        >Upgrade to identifind</a
      >
      <a *ngIf="!hasIdentiFindOption" routerLink="/identifind"
        >Upgrade to identifind</a
      >
      <h5 class="mt-3 mb-5">
        Never lose your pet again with real time PitPat GPS tracking
        <p>and award-winning activity monitoring.</p>
        <p>Add GPS tracking to your identialert plan for just £129, saving £30 compared to RRP.</p>
      </h5>
    </div>
  </div>

  <span *ngIf="desktopViewVisible; else mobileSubscriptionTable">
    <app-subscription-table-desktop
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Buy now'"
      [identifindButtonLabel]="'Learn more'"
      [alertHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentiAlertOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </span>
  <ng-template #mobileSubscriptionTable>
    <app-subscription-table-mobile
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Buy now'"
      [identifindButtonLabel]="'Learn more'"
      [alertHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentiAlertOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </ng-template>
</div>
